import {Component, OnInit, Optional, ChangeDetectionStrategy} from '@angular/core';
import {
  SiteConfigElementComponent
} from "../../../layout/site-config/site-config-element/site-config-element.component";
import { AsyncPipe } from '@angular/common';
import {SiteConfigRule} from '../../../../models/site-config-rule';
import {SiteConfigParam} from '../../../../models/site-config-param';
import {LoaderService} from '../../../../services/loader/loader.service';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {SiteConfigRuleService} from '../../../../services/site-config-rule/site-config-rule.service';
import {SiteConfigParamService} from '../../../../services/site-config-param/site-config-param.service';
import {forkJoin, Observable} from 'rxjs';
import {SiteConfigFormComponent} from '../../../layout/site-config/site-config-form/site-config-form.component';
import {PartnerTabComponent} from '../partner-tab/partner-tab.component';
import {Partner} from '../../../../models/partner/partner';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-partner-site-config-list',
  imports: [
    SiteConfigElementComponent,
    AsyncPipe
],
  templateUrl: './partner-site-config-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-site-config-list.component.scss'
})
@MetaTitle('Partner site config')
export class PartnerSiteConfigListComponent implements OnInit {
  partner: Partner | null = null;
  siteConfigRules: SiteConfigRule[] = [];
  siteConfigParams: SiteConfigParam[] = [];

  constructor(
    private loader: LoaderService,
    private dialog: DialogService,
    private auth: AuthService,
    private siteConfigRuleService: SiteConfigRuleService,
    private siteConfigParamService: SiteConfigParamService,
    @Optional() private partnerTab: PartnerTabComponent
  ) {
  }

  ngOnInit(): void {
    this.partnerTab.partnerSubject.subscribe(partner => {
      this.partner = partner;
      this.refresh();
    });
  }

  refresh(): void {
    this.loader.startLoading();

    forkJoin([
      this.siteConfigRuleService.findAll({partnerId: this.partner?.id}),
      this.siteConfigParamService.findAll()
    ]).subscribe(([siteConfigRules, siteConfigParams]) => {
      this.siteConfigRules = siteConfigRules;
      this.siteConfigParams = siteConfigParams;

      this.loader.stopLoading();
    });
  }

  createRule(): void {
    this.dialog.openDialog(SiteConfigFormComponent, {
      data: {
        partnerId: this.partner?.id
      },
      backdrop: false
    }).subscribe(() => {
      this.refresh();
    });
  }

  hasRoles(roles: string[]): Observable<boolean> {
    return this.auth.hasRoles(roles);
  }
}
